import React from "react";
import { stateHelper } from "../lib/stateHelper";
import useFXForm from "../hooks/useFXForm";
import FormError from "../components/FormError";
import Spinner from "./Spinner";
import FormSuccess from "./FormSuccess";

const UnitedStatesForm = ({ region }) => {
  const {
    formData,
    errors,
    isSubmitting,
    success,
    submitError,
    handleChange,
    handleSubmit,
  } = useFXForm({
    firstName: "",
    lastName: "",
    phone: "",
    country: "",
    state: "",
    zip: "",
    flyPrivate: "",
    currentlyTravel: "",
    flyAnnually: "",
    email: "",
    aboutUs: "",
    askQuestion: "",
    keepInformed: false,
    program: "",
    gclid: "",
    utmCampaign: "",
    utmChannel: "",
    utmContent: "",
    utmMedium: "",
    utmSource: "",
    utmTerm: "",
    region: region ? "US" : "UK",
  });

  return (
    <>
      {isSubmitting ? (
        <Spinner />
      ) : success ? (
        <FormSuccess />
      ) : (
        <form className="contact-form" onSubmit={handleSubmit}>
          {submitError && <FormError />}

          <div className="form-group">
            <div className="form-field">
              <label>First Name*</label>
              <input
                type="text"
                placeholder="First Name"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                className={errors.firstName ? "input-error" : ""}
              />
              {errors.firstName && (
                <span className="error">{errors.firstName}</span>
              )}
            </div>
            <div className="form-field">
              <label>Last Name*</label>
              <input
                type="text"
                placeholder="Last Name"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                className={errors.lastName ? "input-error" : ""}
              />
              {errors.lastName && (
                <span className="error">{errors.lastName}</span>
              )}
            </div>
          </div>

          <div className="form-group">
            <div className="form-field">
              <label>Email*</label>
              <input
                type="email"
                placeholder="Email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className={errors.email ? "input-error" : ""}
              />
              {errors.email && <span className="error">{errors.email}</span>}
            </div>
            <div className="form-field">
              <label>Phone*</label>
              <input
                type="tel"
                placeholder="Phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className={errors.phone ? "input-error" : ""}
              />
              {errors.phone && <span className="error">{errors.phone}</span>}
            </div>
          </div>

          <div className="form-group">
            <div className="form-field">
              <label>Country*</label>
              <select
                name="country"
                value={formData.country}
                onChange={handleChange}
                className={errors.country ? "input-error" : ""}
              >
                <option value="">Select Country</option>
                <option value="US">US</option>
                <option value="Canada">Canada</option>
                <option value="Mexico">Mexico</option>
              </select>
              {errors.country && (
                <span className="error">{errors.country}</span>
              )}
            </div>

            <div
              className={`form-field ${
                formData.country !== "" ? "" : "hidden"
              }`}
            >
              <label>State/Province*</label>
              <select
                name="state"
                value={formData.state}
                onChange={handleChange}
                className={errors.state ? "input-error" : ""}
              >
                <option value="">Select State/Province</option>
                {stateHelper(formData.country)}
              </select>
              {errors.state && <span className="error">{errors.state}</span>}
            </div>
          </div>

          <div className="form-group">
            <div className="form-field">
              <label>ZIP*</label>
              <input
                type="text"
                placeholder="ZIP"
                name="zip"
                value={formData.zip}
                onChange={handleChange}
                className={errors.zip ? "input-error" : ""}
              />
              {errors.zip && <span className="error">{errors.zip}</span>}
            </div>

            <div className="form-field">
              <label>Do you currently fly private?*</label>
              <select
                name="flyPrivate"
                value={formData.flyPrivate}
                onChange={handleChange}
                className={errors.flyPrivate ? "input-error" : ""}
              >
                <option value="">Select an option</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
              {errors.flyPrivate && (
                <span className="error">{errors.flyPrivate}</span>
              )}
            </div>
          </div>

          {formData.flyPrivate === "Yes" && (
            <div className="form-group">
              <div className="form-field">
                <label>How do you currently travel?*</label>
                <select
                  name="currentlyTravel"
                  value={formData.currentlyTravel}
                  onChange={handleChange}
                  className={errors.currentlyTravel ? "input-error" : ""}
                >
                  <option value="">Select an option</option>
                  <option value="Jet Card">Jet Card</option>
                  <option value="Membership">Membership</option>
                  <option value="Fractional">Fractional</option>
                  <option value="Whole Aircraft">Whole Aircraft</option>
                  <option value="Other">Other</option>
                  <option value="Combination">Combination</option>
                </select>
                {errors.currentlyTravel && (
                  <span className="error">{errors.currentlyTravel}</span>
                )}
              </div>

              <div className="form-field">
                <label>How many hours do you fly annually?*</label>
                <select
                  name="flyAnnually"
                  value={formData.flyAnnually}
                  onChange={handleChange}
                  className={errors.flyAnnually ? "input-error" : ""}
                >
                  <option value="">Select an option</option>
                  <option value="Less than 25 hours">Less than 25 hours</option>
                  <option value="25-50 hours">25-50 hours</option>
                  <option value="50-100 hours">50-100 hours</option>
                  <option value="More than 100 hours">
                    More than 100 hours
                  </option>
                </select>
                {errors.flyAnnually && (
                  <span className="error">{errors.flyAnnually}</span>
                )}
              </div>
            </div>
          )}

          <div className="form-group">
            <div className="form-field">
              <label>Which program are you interested in*</label>
              <select
                name="program"
                value={formData.program}
                onChange={handleChange}
                className={errors.program ? "input-error" : ""}
              >
                <option value="">Select an option</option>
                <option value="Fractional">Fractional</option>
                <option value="Jet Leasing">Jet Leasing</option>
                <option value="Jet Card">Jet Card</option>
                <option value="Private Helicopters">Private Helicopters</option>
                <option value="Unlimited Access">Unlimited Access</option>
                <option value="World Access">World Access</option>
                <option value="I Am Unsure">I Am Unsure</option>
              </select>
              {errors.program && (
                <span className="error">{errors.program}</span>
              )}
            </div>

            <div className="form-field">
              <label>How did you hear about us?*</label>
              <select
                name="aboutUs"
                value={formData.aboutUs}
                onChange={handleChange}
                className={errors.aboutUs ? "input-error" : ""}
              >
                <option value="">Select an option</option>
                <option value="Advertising">Advertising</option>
                <option value="Article / Publication">
                  Article / Publication
                </option>
                <option value="Direct Mail (Postal)">
                  Direct Mail (Postal)
                </option>
                <option value="Email">Email</option>
                <option value="Events">Events</option>
                <option value="Partnerships">Partnerships</option>
                <option value="Search / Online">Search / Online</option>
                <option value="TV Commercial">TV Commercial</option>
                <option value="Website">Website</option>
                <option value="Word of Mouth">Word of Mouth</option>
              </select>
              {errors.aboutUs && (
                <span className="error">{errors.aboutUs}</span>
              )}
            </div>
          </div>

          <div className="form-group">
            <div className="form-field">
              <label>Ask us a question</label>
              <textarea
                placeholder="Ask a question"
                name="askQuestion"
                value={formData.askQuestion}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="checkbox-group">
            <div className="checkbox-field">
              <input
                id="keepInformed"
                type="checkbox"
                name="keepInformed"
                checked={formData.keepInformed}
                onChange={handleChange}
              />
              <label htmlFor="keepInformed">
                Opt in to receive future information from Flexjet. By submitting
                your email, you agree to our Privacy Policy. You can unsubscribe
                at any time.
              </label>
            </div>
          </div>

          <input type="hidden" value={formData.gclid} name="gclid" />
          <input
            type="hidden"
            value={formData.utmCampaign}
            name="utmCampaign"
          />
          <input type="hidden" value={formData.utmChannel} name="utmChannel" />
          <input type="hidden" value={formData.utmContent} name="utmContent" />
          <input type="hidden" value={formData.utmMedium} name="utmMedium" />
          <input type="hidden" value={formData.utmSource} name="utmSource" />
          <input type="hidden" value={formData.utmTerm} name="utmTerm" />

          <div className="submit">
            <input type="submit" value="Submit" className="submit-btn" />
          </div>
        </form>
      )}
    </>
  );
};

export default UnitedStatesForm;
